import actions from "./Actions";

export default {
  namespaced: true,

  actions: actions
};
